var React = require('react');

function BigStoryRect (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-565 -148.287L-565 130.101L80.732 478.2L80.732 199.812L-565 -148.287Z","fill":"#BBBBBB"}));
}

BigStoryRect.defaultProps = {"width":"81","height":"479","viewBox":"0 0 81 479","fill":"none"};

module.exports = BigStoryRect;

BigStoryRect.default = BigStoryRect;
